import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfigFor } from './app/app.config';
import { loadRuntimeEnvironment } from './app/core/configuration/runtime-environment';

// L'indirizzo del BFF si legge prima di avviare: e' cio' con cui ogni provider costruisce le proprie
// chiamate, e chiederlo dopo vorrebbe dire una prima chiamata partita verso l'indirizzo sbagliato.
loadRuntimeEnvironment()
  .then((environment) => bootstrapApplication(AppComponent, appConfigFor(environment)))
  .catch((err) => console.error(err));
